import React from "react";
import Reservation from "../../Component/Reservations";

export default function CommuteReservation({ reservationMode = "예약" }) {
  return <Reservation type="통근" reservationMode={reservationMode} />;
}
